import { useDispatch, useSelector } from 'react-redux';

import {
  closeChooseCampaignDrawer,
  openChooseCampaignDrawer,
} from 'modules/experiments/ducks/actions';
import { getIsChooseCampaignTakeoverOpen } from 'modules/experiments/ducks/selectors';

export const useChooseCampaignTakeover = () => {
  const dispatch = useDispatch();

  const openChooseCampaignTakeover = () => {
    dispatch(openChooseCampaignDrawer());
  };

  const closeChooseCampaignTakeover = () => {
    dispatch(closeChooseCampaignDrawer());
  };

  const isChooseCampaignTakeoverOpen = useSelector(getIsChooseCampaignTakeoverOpen);

  return {
    isChooseCampaignTakeoverOpen,
    openChooseCampaignTakeover,
    closeChooseCampaignTakeover,
  };
};
